import Vue from 'vue'
import TcwForm from '@/components/common/form/TcwForm.vue'
import TcwFormItem from '@/components/common/form/TcwFormItem.vue'
import TcwFormItemCheckBox from '@/components/common/form/TcwFormItemCheckBox.vue'
import TcwFormItemDate from '@/components/common/form/TcwFormItemDate.vue'
import TcwFormItemJikan from '@/components/common/form/TcwFormItemJikan.vue'
import TcwFormItemLabel from '@/components/common/form/TcwFormItemLabel.vue'
import TcwFormItemNumber from '@/components/common/form/TcwFormItemNumber.vue'
import TcwFormItemSelect from '@/components/common/form/TcwFormItemSelect.vue'
import TcwFormItemSwitch from '@/components/common/form/TcwFormItemSwitch.vue'
import TcwFormItemText from '@/components/common/form/TcwFormItemText.vue'
import TcwFormItemTextarea from '@/components/common/form/TcwFormItemTextarea.vue'
import TcwFormItemRadioGroup from '@/components/common/form/TcwFormItemRadioGroup.vue'
import TcwFormItemFile from '@/components/common/form/TcwFormItemFile.vue'
import TcwFormItemFileUpload from '@/components/common/form/TcwFormItemFileUpload.vue'
import TcwDialog from '@/components/common/dialog/TcwDialog.vue'

Vue.component('TcwForm', TcwForm)
Vue.component('TcwFormItem', TcwFormItem)
Vue.component('TcwFormItemCheckBox', TcwFormItemCheckBox)
Vue.component('TcwFormItemDate', TcwFormItemDate)
Vue.component('TcwFormItemJikan', TcwFormItemJikan)
Vue.component('TcwFormItemLabel', TcwFormItemLabel)
Vue.component('TcwFormItemNumber', TcwFormItemNumber)
Vue.component('TcwFormItemSelect', TcwFormItemSelect)
Vue.component('TcwFormItemSwitch', TcwFormItemSwitch)
Vue.component('TcwFormItemText', TcwFormItemText)
Vue.component('TcwFormItemTextarea', TcwFormItemTextarea)
Vue.component('TcwFormItemRadioGroup', TcwFormItemRadioGroup)
Vue.component('TcwFormItemFile', TcwFormItemFile)
Vue.component('TcwFormItemFileUpload', TcwFormItemFileUpload)
Vue.component('TcwDialog', TcwDialog)
